import { c as _c } from "react/compiler-runtime";
import { Box, Flex } from "@chakra-ui/react";
import { defineMessages, useIntl } from "react-intl";
import { METRIC_VIEW_AVAILABILITY, ToggleMetric, ViewMode } from "@/utils/metricUtils";
export interface ViewModeButtonProps {
  selectedMetric: ToggleMetric;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}
const messages = defineMessages({
  trajectories: {
    id: "viewMode.trajectories",
    defaultMessage: "Trajectories View"
  },
  aggregate: {
    id: "viewMode.aggregate",
    defaultMessage: "Aggregate View"
  }
});
interface ViewButtonProps {
  mode: ViewMode;
  isActive: boolean;
  isDisabled: boolean;
  label: string;
  onClick: () => void;
  borderLeftRadius: string;
  borderRightRadius: string;
  "data-testid": string;
}
const ViewButton = t0 => {
  const $ = _c(16);
  const {
    isActive,
    isDisabled,
    label,
    onClick,
    borderLeftRadius,
    borderRightRadius,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== isActive || $[1] !== isDisabled || $[2] !== onClick) {
    t1 = () => {
      if (isDisabled || isActive) {
        return;
      }
      onClick();
    };
    $[0] = isActive;
    $[1] = isDisabled;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== isActive || $[5] !== isDisabled) {
    const getStyles = () => {
      if (isDisabled) {
        return {
          bg: "grey.200",
          color: "grey.400",
          borderColor: "grey.200",
          cursor: "not-allowed",
          fontWeight: "normal"
        };
      }
      if (isActive) {
        return {
          bg: "grey.700",
          color: "white",
          borderColor: "grey.700",
          cursor: "default",
          fontWeight: "semibold"
        };
      }
      return {
        bg: "transparent",
        color: "grey.700",
        borderColor: "grey.700",
        cursor: "pointer",
        fontWeight: "normal"
      };
    };
    t2 = getStyles();
    $[4] = isActive;
    $[5] = isDisabled;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const styles = t2;
  const t3 = isDisabled ? "true" : undefined;
  const t4 = isActive ? "true" : undefined;
  let t5;
  if ($[7] !== borderLeftRadius || $[8] !== borderRightRadius || $[9] !== dataTestId || $[10] !== handleClick || $[11] !== label || $[12] !== styles || $[13] !== t3 || $[14] !== t4) {
    t5 = <Box as="button" flex="1" h="9" borderWidth="button" borderStyle="solid" borderLeftRadius={borderLeftRadius} borderRightRadius={borderRightRadius} fontSize="sm" onClick={handleClick} aria-disabled={t3} data-active={t4} data-testid={dataTestId} {...styles}>{label}</Box>;
    $[7] = borderLeftRadius;
    $[8] = borderRightRadius;
    $[9] = dataTestId;
    $[10] = handleClick;
    $[11] = label;
    $[12] = styles;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export const ViewModeButtons = t0 => {
  const $ = _c(21);
  const {
    selectedMetric,
    viewMode,
    onViewModeChange
  } = t0;
  const intl = useIntl();
  const availability = METRIC_VIEW_AVAILABILITY[selectedMetric];
  const t1 = viewMode === ViewMode.trajectories;
  const t2 = !availability.trajectories;
  let t3;
  if ($[0] !== intl) {
    t3 = intl.formatMessage(messages.trajectories);
    $[0] = intl;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onViewModeChange) {
    t4 = () => onViewModeChange(ViewMode.trajectories);
    $[2] = onViewModeChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <ViewButton mode={ViewMode.trajectories} isActive={t1} isDisabled={t2} label={t3} onClick={t4} borderLeftRadius="button" borderRightRadius="0" data-testid="view-mode-trajectories" />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = viewMode === ViewMode.aggregate;
  const t7 = !availability.aggregate;
  let t8;
  if ($[9] !== intl) {
    t8 = intl.formatMessage(messages.aggregate);
    $[9] = intl;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onViewModeChange) {
    t9 = () => onViewModeChange(ViewMode.aggregate);
    $[11] = onViewModeChange;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <ViewButton mode={ViewMode.aggregate} isActive={t6} isDisabled={t7} label={t8} onClick={t9} borderLeftRadius="0" borderRightRadius="button" data-testid="view-mode-aggregate" />;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <Flex flexShrink={0} minWidth="280px" data-testid="view-mode-segment">{t5}{t10}</Flex>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};